import * as ng from 'angular';
import { PdfViewer } from './pdf-viewer.directive';

export const PdfViewerModule: string =
    ng.module('pdf-viewer', [
    ])
        .directive('pdfViewer', PdfViewer)
        .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/pdf-viewer/pdf-viewer.module.ts